import type { ColumnType } from '../lib/api';
import { R, mono } from '../lib/ui';

const base: React.CSSProperties = {
  flex: '0 0 auto',
  display: 'grid',
  placeItems: 'center',
  width: 13,
  height: 13,
  fontFamily: mono,
  fontSize: 9.5,
  color: R.textMuted,
  letterSpacing: 0,
};

/**
 * Значок типа слева от названия колонки. Формула перебивает тип и рисуется
 * акцентной «ƒ»; у Any значка нет вовсе.
 */
export function ColumnTypeIcon({
  type, isFormula,
}: {
  type: ColumnType;
  isFormula?: boolean;
}) {
  if (isFormula) {
    return (
      <span style={{ ...base, color: R.accent }} title="Формула">
        ƒ
      </span>
    );
  }

  if (!type || type === 'Any') return null;

  switch (type) {
    case 'Date':
    case 'DateTime':
      return (
        <span style={base} title={type}>
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="5" width="18" height="16" />
            <path d="M3 10h18M8 3v4M16 3v4" />
          </svg>
        </span>
      );

    case 'Numeric':
    case 'Int':
      return (
        <span style={base} title={type}>
          1.2
        </span>
      );

    case 'Bool':
      return (
        <span style={base} title="Флажок (галочка)">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="16" />
            <path d="m7 12 3 3 7-7" />
          </svg>
        </span>
      );

    case 'Choice':
      return (
        <span style={base} title="Список">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
          </svg>
        </span>
      );

    default:
      return (
        <span style={base} title="Текст">
          T
        </span>
      );
  }
}
